export class NavLink {
    public label: string;
    public route: string;

    constructor(label_: string, route_: string) {
        this.label = label_;
        this.route = route_;
    }
}
